<template>
  <el-card>
    <div v-if="!isEmpty">
      <Timeline>
        <TimelineItem
          v-for="(item, index) in productProofingData"
          :key="index"
          v-bind="item"
        >
          <template #default="{ item }">
            <div
              class="product-proofing__wrapper"
              v-for="(tableData, index) in item.content"
              :key="index"
            >
              <div class="product-proofing__container mt-2">
                <div class="product-proofing__head">
                  <div>NO：ABSXP24010001-1</div>
                  <div>颜色及印花图案</div>
                </div>
                <div class="product-proofing__value">
                  <div>
                    <div class="fs-w mb-5px">产品尺寸</div>
                    <div class="color-4f mb-10px">18"x18"</div>
                    <div class="fs-w mb-5px">产品报价</div>
                    <div class="color-4f mb-30px">
                      <span class="wrapper__quotations">FOB</span>
                      <span class="wrapper__quotations-price">10.99</span>
                      <span class="wrapper__quotations-unit">USD</span>
                    </div>
                    <div class="fs-w mb-5px">打样工厂</div>
                    <div class="color-4f mb-10px">苏州合祥纺织科技有限公司</div>
                    <div class="fs-w mb-5px">工厂业务</div>
                    <div class="color-4f mb-10px">Zhangxu-张旭</div>
                    <div class="fs-w mb-5px">具体说明</div>
                    <div class="color-4f mb-5px">经纱：雪尼尔（白色）</div>
                    <div class="color-4f mb-5px">
                      纬纱：雪尼尔+桑子纱加粗 四角流苏，2PC
                    </div>
                  </div>
                  <div class="sample_info__container">
                    <Card :cardInfo="{}" />
                    <Card :cardInfo="{}" />
                    <Card :cardInfo="{}" />
                    <Card :cardInfo="{}" />
                    <Card :cardInfo="{}" />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </TimelineItem>
      </Timeline>
    </div>
    <div v-else class="not-data__container">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
        </p>
      </div>
    </div>
  </el-card>
</template>

<script>
import Timeline from '../timeline/index.vue'
import TimelineItem from '../timeline/item.vue'
import Card from './card.vue'
export default {
  components: { Timeline, TimelineItem, Card },
  data() {
    return {
      productProofingData: [
        {
          type: 'T',
          title: '打样单号：SP202401190001 ',
          time: '2024-01-10 10:10:30',
          name: 'Ping-鄢萍',
          avatar:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202211/eb0e81e1ace7616d9fe1f1008cf9c39f.jpg?Expires=2017386112&OSSAccessKeyId=LTAI4G9GTRRdivUVG4GXBpXM&Signature=n0PPMOE712DKaryzWZeRn03cOro%3D',
          content: [{}],
        },
        {
          type: 'T',
          title: '打样单号：SP202401190001 ',
          time: '2024-01-10 10:10:30',
          name: 'Ping-鄢萍',
          avatar:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202211/eb0e81e1ace7616d9fe1f1008cf9c39f.jpg?Expires=2017386112&OSSAccessKeyId=LTAI4G9GTRRdivUVG4GXBpXM&Signature=n0PPMOE712DKaryzWZeRn03cOro%3D',
          content: [{}, {}],
        },
      ],
      loading: false,
    }
  },
  computed: {
    isEmpty() {
      return !this.productProofingData || !this.productProofingData.length
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  padding: 20px 15px;
}
.product-proofing__container {
  .product-proofing__head {
    display: flex;
    font-size: 13px;
    align-items: center;
    div {
      padding: 10px;
      display: flex;
      background-color: #fafafa;
      color: #303133;
      border: 1px solid #efefef;
    }
    > div:first-child {
      width: 240px;
    }
    > div:last-child {
      border-left: none;
      flex: 1;
    }
  }
  .product-proofing__value {
    display: flex;
    font-size: 13px;
    > div {
      display: flex;
      border: 1px solid #efefef;
    }
    > div:first-child {
      width: 240px;
      padding: 10px;
      border-top: none;
      background-color: white;
      flex-direction: column;
    }
    > div:last-child {
      padding: 10px 0;
      border-left: none;
      border-top: none;
      background-color: #efefef;
      flex: 1;
    }
    .sample_info__container {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
    }
  }
}
.wrapper__quotations {
  font-size: 14px;
  font-weight: 600;
  color: #4f4f4f;
  margin-right: 10px;
}
.wrapper__quotations-price {
  color: #28a745;
  font-size: 18px;
  font-weight: 600;
  margin-right: 2px;
}
.wrapper__quotations-unit {
  color: #4f4f4f;
  font-size: 12px;
}
.product-proofing__wrapper:last-child {
  padding-bottom: 20px;
}
.tag {
  padding: 2px 17px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  background-color: #efefef;
  color: #4f4f4f;
}
.not-data__container {
  height: 500px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fs-w {
  color: #6c757d;
  font-weight: 600;
  font-size: 14px;
}
.color-4f {
  color: #4f4f4f;
}
.mb-5px {
  margin-bottom: 5px;
}
.mb-10px {
  margin-bottom: 10px;
}
.mb-30px {
  margin-bottom: 30px;
}
.mr-3px {
  margin-right: 3px;
}
.label-key {
  color: #6c757d;
  font-weight: 600;
}
.fs-18 {
  font-size: 18px;
}
.color-blue {
  color: #007bff;
}
.fs-12 {
  font-size: 12px;
}
.fs-600w {
  font-weight: 600;
}
</style>
